import { ClipboardCheck, Network, CalendarCheck, Timer, Gem, Paintbrush, ShieldCheck, MapPin } from "lucide-react";
import { Reveal } from "../../lib/reveal";
import { ENGAGEMENTS } from "../../data/content";

const ICONS = {
  etude: ClipboardCheck,
  coordination: Network,
  suivi: CalendarCheck,
  planning: Timer,
  materiaux: Gem,
  finitions: Paintbrush,
  decennale: ShieldCheck,
  local: MapPin,
};

const Engagements = () => (
  <section data-testid="engagements-section" className="bg-bati-blue py-24 text-white lg:py-32">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal className="mb-16 max-w-3xl">
        <p className="mb-4 flex items-center gap-3 text-[12px] font-bold uppercase tracking-[0.22em] text-bati-sky">
          <span className="h-px w-10 bg-bati-sky" /> Nos engagements
        </p>
        <h2 className="font-display text-4xl font-extrabold tracking-tight sm:text-5xl">
          La maîtrise du chantier, du premier rendez-vous à la livraison
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 gap-px bg-white/15 sm:grid-cols-2 lg:grid-cols-4">
        {ENGAGEMENTS.map((e, i) => {
          const Icon = ICONS[e.key];
          return (
            <Reveal key={e.key} delay={i * 0.05} className="bg-bati-blue">
              <div className="group flex h-full flex-col gap-5 p-8 transition-colors duration-300 hover:bg-[#013a85]" data-testid={`engagement-${e.key}`}>
                <span className="grid h-11 w-11 place-items-center border border-white/25 text-bati-sky transition-colors duration-300 group-hover:border-bati-sky">
                  <Icon className="h-5 w-5" strokeWidth={1.8} />
                </span>
                <p className="font-display text-lg font-bold leading-snug">{e.label}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default Engagements;
